import React from "react";
import { Link as MuiLink } from "@mui/material";
import { DataCardShell } from "../../../../../components/responsive";
import Helpers from "../../../../../components/Helpers";
import MasterRowActions from "../../../../../components/masterData/MasterRowActions";

export function DeaneryCard({
  row,
  isAdmin,
  onEdit,
  onDelete,
  onOpenParishes,
}: {
  row: any;
  isAdmin: boolean;
  onEdit: (row: any) => void;
  onDelete: (row: any) => void;
  onOpenParishes: (row: any) => void;
}) {
  return (
    <DataCardShell
      title={row.deaneryName || "—"}
      subtitle={[row.deaneryCode, row.parishCategoryName]
        .filter(Boolean)
        .join(" · ")}
      fields={[
        {
          label: "Parishes",
          value: (
            <MuiLink
              component="button"
              type="button"
              onClick={() => onOpenParishes(row)}
              sx={{ cursor: "pointer" }}
            >
              {row.parishCount ?? 0}
            </MuiLink>
          ),
        },
        {
          label: "Created",
          value: row.createdAt
            ? Helpers.convertUtcToTimezone(row.createdAt, "MM-DD-YYYY")
            : "—",
        },
      ]}
      primaryAction={
        isAdmin ? (
          <MasterRowActions
            onEdit={() => onEdit(row)}
            onDelete={() => onDelete(row)}
          />
        ) : undefined
      }
    />
  );
}
